// Words kept lowercase in title case unless they are the first or last word.
const TITLE_CASE_MINOR_WORDS = new Set([
  'a',
  'an',
  'and',
  'as',
  'at',
  'but',
  'by',
  'for',
  'if',
  'in',
  'nor',
  'of',
  'off',
  'on',
  'or',
  'per',
  'the',
  'to',
  'up',
  'via',
  'vs',
  'with',
])

// Title-cases a button label: capitalizes the first letter of each word (always
// the first and last) while keeping minor words lowercase. The rest of each
// word is preserved so acronyms and brands survive (e.g. "AI", "LinkedIn").
export function toTitleCase(label: string): string {
  const words = label.split(' ')
  return words
    .map((word, index) => {
      if (word.length === 0) return word
      const isFirstOrLast = index === 0 || index === words.length - 1
      if (!isFirstOrLast && TITLE_CASE_MINOR_WORDS.has(word.toLowerCase())) {
        return word.toLowerCase()
      }
      return `${word[0].toUpperCase()}${word.slice(1)}`
    })
    .join(' ')
}
